// Constants for the consent versions
export const TOS_VERSION = 'signup_consent_version_terms_of_service_20240801';
export const DPA_VERSION = 'signup_consent_version_dpa_20250207';
export const PP_VERSION = 'signup_consent_version_privacy_policy_20250501';

// AuthError code Supabase returns when CAPTCHA protection rejects the request's token.
export const CAPTCHA_FAILED_ERROR_CODE = 'captcha_failed';

export const ERROR_CAPTCHA_FAILED = 'ERROR_CAPTCHA_FAILED';

export const isCaptchaFailedAuthError = (error: { code?: string } | null | undefined): boolean => error?.code === CAPTCHA_FAILED_ERROR_CODE;

// Character chatbot acknowledgment version - value stored in user_attributes
// Name format: character_chatbot_ack_{roomToolFormId}
export const CHARACTER_CHATBOT_ACK_VERSION = 'version_20260122';
